import { createContext } from 'react';

// The entity a reference chip just panned to; cards read it without re-creating the flow nodes.
export const FocusedEntityContext = createContext<number | undefined>(
  undefined
);
